import * as React from 'react';

export interface VisibilityDetectorProps {
  onVisible?(): void;
  onHidden?(): void;
  onFirstVisible?(): void;
  style?: React.CSSProperties;
}

export class VisibilityDetector extends React.PureComponent<VisibilityDetectorProps> {
  private readonly ref: React.RefObject<HTMLDivElement> = React.createRef();
  private observer?: IntersectionObserver;
  state = { wasVisibled: false };

  componentDidMount() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio > 0) {
          if (!this.state.wasVisibled) {
            this.state.wasVisibled = true;
            this.props.onFirstVisible?.();
          }
          this.props.onVisible?.();
        } else {
          this.props.onHidden?.();
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0.0],
      },
    );

    if (this.ref.current) {
      this.observer.observe(this.ref.current);
    }
  }

  componentWillUnmount() {
    this.observer && this.observer.disconnect();
    this.observer = undefined;
  }

  render() {
    return (
      <div style={this.props.style} ref={this.ref}>
        {this.props.children}
      </div>
    );
  }
}
